import SmoothScroll from 'smooth-scroll'
import Navigation from './lib/navigation'
import stickyContent from './lib/stickyContent'
import Splide from '@splidejs/splide'

/* -------------------------------------------------------------------
  utility
------------------------------------------------------------------- */
const smoothScroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
  popstate: true,
  updateURL: false
})

Navigation('header-nav__btn', 'header-nav-sp')

stickyContent([['scroll-top', '']])

// slider -------------------------------------------------

const options = {
  type: 'loop',
  mediaQuery: 'min',
  arrows: false,
  pagination: false,
  autoWidth: true,
  autoplay: true,
  interval: 0,
  speed: 100000,
  easing: 'linear',
  drag: false,
  breakpoints: {
    768: {
      // destroy: true,
    },
  },
}
if(document.getElementById('gallery')) {
  new Splide( '#gallery', options ).mount()
} else if (document.getElementById('slider')) {
  new Splide( '#slider', options ).mount()
}
